import { render, staticRenderFns } from "./clientProfile.vue?vue&type=template&id=dfc5ba2a&scoped=true"
import script from "./clientProfile.vue?vue&type=script&lang=js"
export * from "./clientProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc5ba2a",
  null
  
)

export default component.exports